import React, { useMemo } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { AdminPageHeader } from '../ui';
import ReportsSubNav from '../../head-doctor/reports/ReportsSubNav';
import AdminReportsDomainNav from './AdminReportsDomainNav';
import { ADMIN_RECEPTION_NAV } from './adminAnalyticsNav';
import '../../head-doctor/HeadDoctorDashboard.css';
import '../../receptionist/ReceptionistDashboard.css';
import './AdminClinicalAnalyticsLayout.css';

const RECEPTION_COPY = {
  SUB_NAV_ARIA: 'Sections rapports réception',
  SUB_PASSAGES: 'Passages',
  SUB_RDV: 'Rendez-vous'
};

const RECEPTION_NAV_ICONS = {
  reporting: { icon: 'signIn' },
  rendezVous: { icon: 'calendar' }
};

export default function AdminReceptionReportsLayout() {
  const { toast } = useOutletContext() || {};
  const outletCtx = useMemo(() => ({ toast: toast || (() => {}) }), [toast]);

  return (
    <div className="adm-analytics-page hd-reports-page">
      <AdminPageHeader
        badge="Administration"
        title="Rapports réception"
        description="Journal des passages et agenda des rendez-vous — exports CSV institutionnels."
      />
      <AdminReportsDomainNav />

      <section className="hd-reports-shell mb-4">
        <ReportsSubNav
          copy={RECEPTION_COPY}
          navItems={ADMIN_RECEPTION_NAV}
          navIcons={RECEPTION_NAV_ICONS}
        />

        <div className="hd-reports-outlet">
          <Outlet context={outletCtx} />
        </div>
      </section>
    </div>
  );
}
